<template>
    <div>
        <li v-if="!subMenus">
            <router-link 
                :to="link" 
                class="
                    flex align-items-center 
                    cursor-pointer p-3 border-round 
                    navtext hover:navtexthover 
                    transition-duration-150 
                    transition-colors p-ripple
                    sidebar-link-app 
                    parent-link" 
                :id="link" append exact
            >
                <!-- <i class="pi mr-2" :class="icon"></i> -->
                <span class="material-symbols-outlined icon-class pr-3">{{icon}}</span>
                <!-- <span class="material-icons icon-class pr-2">{{icon}}</span> -->
                <span class="font-medium">{{title}}</span>
            </router-link>
        </li>
        <li v-else>
            <a
                v-ripple
                v-styleclass="{
                    selector: '@next',
                    enterClass: 'hidden',
                    enterActiveClass: 'slidedown',
                    leaveToClass: 'hidden',
                    leaveActiveClass: 'slideup'
                }"
                class=
                    "
                        flex align-items-center 
                        cursor-pointer p-3 border-round 
                        transition-duration-150 
                        transition-colors p-ripple
                    "
            >
                <i class="pi mr-2" :class="icon"></i>
                <span class="font-medium">{{title}}</span>
                <i class="pi pi-chevron-down ml-auto"></i>
            </a>
            <ul class="
                list-none py-0 pl-3 pr-0 m-0 
                hidden overflow-y-hidden 
                transition-all transition-duration-400
                transition-ease-in-out"
            >
                <li v-for="(subMenu, index) in subMenus" :key="index">
                    <navlink
                        :title="subMenu.title"
                        :link="subMenu.link"
                        :icon_type="subMenu.icon_type"
                        :icon="subMenu.icon"
                        :subMenus="subMenu.subMenus"
                        :showmenu="showmenu"
                        :isOpen="isOpen"
                    />
                </li>
            </ul>
        </li>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: ["title", "link", "icon", "subMenus", "showmenu", "isOpen", "icon_type"],
    components: {   
    },
    data(){
        return{
            visible: true 
        }
    },
    computed: {
        
    },
    methods:{
        navigateTo(url: string) {
            window.history.pushState({}, '', url);
        },
    },
})
</script>
<style>
.p-menubar{
    border-radius: 0;
}
</style>
<style src="./navlink.scss" lang="scss" scoped/>  